/* unplugin-vue-components disabled */import script from "./template-manage.vue?vue&type=script&setup=true&lang=js"
export * from "./template-manage.vue?vue&type=script&setup=true&lang=js"

import "./template-manage.vue?vue&type=style&index=0&id=3dba3030&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dba3030"]])

export default __exports__